import { useState } from "react";
import { useSEO } from "@/hooks/useSEO";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import RecentPricesSection from "@/components/RecentPricesSection";
import PriceEstimator from "@/components/PriceEstimator";
import ServiceAreasSection from "@/components/ServiceAreasSection";
import WhyChooseUsSection from "@/components/WhyChooseUsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import StickyCtaBar from "@/components/StickyCtaBar";

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useSEO({
    title: "Stump Grinding Near Me | Stump Grinding Tucson AZ | Stump Removal Service",
    canonical: "https://tucsonstumpgrinding.com/",
    description: "Professional stump grinding service in Tucson AZ. Licensed and insured stump removal near me serving Oro Valley, Catalina, Sahuarita, SaddleBrooke and Oracle. Tree stump grinding service with free estimates. Same-day stump grinding available.",
    ogTitle: "Stump Grinding Near Me | Tucson AZ Stump Removal Service",
    ogDescription: "Professional stump grinding service in Tucson AZ. Licensed and insured tree stump removal. Free estimates. Same-day service available.",
    ogUrl: "https://tucsonstumpgrinding.com/",
  });

  return (
    <div className="min-h-screen bg-white">
      <Header 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />
      <main>
        <HeroSection />
        <ServicesSection />
        <RecentPricesSection />
        <PriceEstimator />
        <WhyChooseUsSection />
        <ServiceAreasSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <MobileCTA />
      <StickyCtaBar />
    </div>
  );
};

export default LandingPage;
